var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiltrar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono-filtrar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_list_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91992 5.35997C1.91992 5.71197 2.20792 5.99997 2.55992 5.99997H12.7999C13.1519 5.99997 13.4399 5.71197 13.4399 5.35997C13.4399 5.00797 13.1519 4.71997 12.7999 4.71997H2.55992C2.20792 4.71997 1.91992 5.00797 1.91992 5.35997ZM7.03992 12.4H8.31992C8.67192 12.4 8.95992 12.112 8.95992 11.76C8.95992 11.408 8.67192 11.12 8.31992 11.12H7.03992C6.68792 11.12 6.39992 11.408 6.39992 11.76C6.39992 12.112 6.68792 12.4 7.03992 12.4ZM10.8799 9.19997H4.47992C4.12792 9.19997 3.83992 8.91197 3.83992 8.55997C3.83992 8.20797 4.12792 7.91997 4.47992 7.91997H10.8799C11.2319 7.91997 11.5199 8.20797 11.5199 8.55997C11.5199 8.91197 11.2319 9.19997 10.8799 9.19997Z",
    fill: "#093C5D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltrar);
export default __webpack_public_path__ + "static/media/Filtrar.657ac24908bcbcc2b28bfd590ba224b6.svg";
export { ForwardRef as ReactComponent };